import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Project } from '@interfaces/projects';
import { download_project_csv_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';

const GOOGLE_SHEET_NAME_FINAL = 'final';

type CSVDownloadLinkProps = Pick<Project, 'id' | 'slug'> & {
  sheetName?: string;
};

const CSVDownloadLink = ({
  id: projectId,
  sheetName = GOOGLE_SHEET_NAME_FINAL,
  slug: projectSlug,
}: CSVDownloadLinkProps) => {
  const { Track, trackEvent } = useEventTracking({
    contentType: ContentType.Project,
    contentId: projectId,
  });

  return (
    <Track>
      <p>
        <a
          className="text-body-md !text-primary-magenta hover:!text-primary-magenta"
          href={download_project_csv_path(projectSlug, {
            sheet_name: sheetName,
          })}
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.CSVDownloadLink }))}
        >
          Download CSV
        </a>
      </p>
    </Track>
  );
};

export default CSVDownloadLink;
